export default "__VITE_ASSET__DBIe3tMY__"